import { useSetAtom } from 'jotai';
import { useCallback } from 'react';

import { loginReturnAtom } from '@/components/DialogStage/atom';
import { useStage } from '@/components/DialogStage/useStage';
import { useOpenAuthDialog } from '@/components/Modals/AuthDialog/useOpenAuthDialog';
import { useIsLoggedIn } from '@/hooks/auth';

/**
 * Entry point for the Partner application journey (DEV-6758). Logged-in
 * users go straight to the application form scene; visitors get the auth
 * dialog with the 'partner-application' context (returning users see login,
 * new users see sign-up) and continue into the form once authenticated —
 * via `loginReturnAtom` on the login path and `usePartnerSignupSuccess` on
 * the signup paths. Users who are already partners are redirected to the
 * not-eligible scene by the form itself (DEV-6875).
 */
export const useOpenPartnerApplication = () => {
  const isLoggedIn = useIsLoggedIn();
  const { open } = useStage();
  const openAuthDialog = useOpenAuthDialog();
  const setLoginReturn = useSetAtom(loginReturnAtom);

  return useCallback(() => {
    if (isLoggedIn) {
      open('partner.application');
      return;
    }
    setLoginReturn('partner.application');
    openAuthDialog({ context: 'partner-application' });
  }, [isLoggedIn, open, openAuthDialog, setLoginReturn]);
};
